/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.15 ./KWH-18M-SF113_SX.glb 
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model(props) {
  const { nodes, materials } = useGLTF('/3d/KWH-18M-SF113_SX.glb')
  
 const { wallcolor, covercolor, tinsmithcolorhex } = props;
 return (
 
    <group {...props} dispose={null}>
      <mesh geometry={nodes.IfcBeamLATTONERIA_COPERTURA.geometry} material={materials.ZINCO_LATTONERIA} material-color={tinsmithcolorhex || '#0E294B'}  rotation={[0, 0, -Math.PI]} scale={-1} />
      <mesh geometry={nodes.IfcBeamPANNELLO_COPERTURA_50.geometry} material={materials.PANNELLO_COPERTURA} material-color={covercolor || '#0E294B'}  rotation={[-3.031, Math.PI / 2, 0]} scale={-1} />
      <mesh geometry={nodes.IfcColumnPANNELLO_PARETE_50.geometry} material={materials.PANNELLO_PARETE} material-color={wallcolor || '#0E294B'}  rotation={[-Math.PI, 1.571, 0]} scale={-1} />
      <mesh geometry={nodes.IfcColumnLATTONERIA_PORTE.geometry} material={materials.ZINCO_LATTONERIA} material-color={tinsmithcolorhex || '#0E294B'}  rotation={[-Math.PI, 1.571, 0]} scale={-1} />
      <mesh geometry={nodes.IfcPlatePORTA.geometry} material={materials.PANNELLO_PORTA} rotation={[-Math.PI / 2, 0, Math.PI / 2]} scale={-1} />
      <mesh geometry={nodes.IfcBeamSTRUTTURA_CARPENTERIA.geometry} material={materials['ACCIAIO-S275JR']} rotation={[0.111, 0, 0]} scale={-1} />
    </group>
  )
}

useGLTF.preload('/3d/KWH-18M-SF113_SX.glb')
